import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthContext.js";
import bgImage from "../../../assets/images/1768687732162_3D.png";

import { FileText, Languages, LogOut, Scale, SearchCheck } from "lucide-react";

const services = [
  { name: "محامون", slug: "lawyer", icon: Scale },
  { name: "مترجمون", slug: "translator", icon: Languages },
  { name: "موثقون", slug: "notary", icon: FileText },
  { name: "محضرون قضائيون", slug: "judicial_expert", icon: SearchCheck },
];

export default function Dashboard() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [search, setSearch] = useState("");

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setUser(null);
    navigate("/login");
  };

  const filteredServices = services.filter((service) =>
    service.name.includes(search),
  );

  return (
    <div
      className="min-h-screen"
      style={{
        backgroundImage: `linear-gradient(
          rgba(0,0,0,0.4),
          rgba(0,0,0,0.4)
        ), url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Header */}
      <div className="bg-gradient-to-r from-green-600/90 to-green-500/90 px-6 py-4 flex justify-between items-center">
        <h1 className="text-xl font-bold text-white">الوسيط القضائي</h1>

        <div className="flex gap-3">
          <button
            onClick={() => navigate("/profile")}
            className="px-4 py-2 text-sm rounded-md border border-white text-white hover:bg-white/10 transition"
          >
            الملف الشخصي
          </button>

          <button
            onClick={handleLogout}
            className="px-4 py-2 text-sm rounded-md bg-white/20 text-white hover:bg-white/30 flex items-center gap-1 transition"
          >
            <LogOut className="w-4 h-4" />
            تسجيل الخروج
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-6xl mx-auto px-6 py-12">
        {/* Logo */}
        <div className="max-w-md mx-auto mb-10 flex justify-center">
          <img
            src="/images/logo.png"
            alt="Logo"
            className="w-40 h-auto drop-shadow-md"
          />
        </div>

        {/* Services */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {filteredServices.length > 0 ? (
            filteredServices.map((service) => {
              const Icon = service.icon;

              return (
                <div
                  key={service.slug}
                  onClick={() => navigate(`/services/${service.slug}`)}
                  className="cursor-pointer bg-white/95 backdrop-blur rounded-2xl p-6 shadow-lg hover:-translate-y-1 hover:shadow-2xl transition-all duration-300"
                >
                  <div className="flex justify-center mb-4">
                    <div className="w-14 h-14 rounded-xl bg-green-100 flex items-center justify-center">
                      <Icon className="w-7 h-7 text-green-600" />
                    </div>
                  </div>

                  <h3 className="text-center font-medium text-gray-800">
                    {service.name}
                  </h3>

                  <p className="text-center text-sm text-gray-500 mt-2">
                    حجز مواعيد وخدمات رسمية
                  </p>
                </div>
              );
            })
          ) : (
            <p className="col-span-full text-center text-white text-lg">
              لا توجد نتائج
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
